
import Vue from "vue";
import { printHumanFloat, printLocalDate } from "@/utils/pretty-print";
import AppSelectBankType from "@/components/bank/SelectBankType.vue";
import {BankService, BookYearService, DossierConfigService, UserConfigService} from "@/services";
import BankBalance from "@/models/base/bank-balance";
import {Bank, BankType} from "@/models/base";
import {BankKind} from "@/models/base/bank";
import {CashierSettings} from "@/models/user-configs/cashier-settings";
export default Vue.extend({
	filters: {
		printHumanFloat
	},
	data() {
		return {
			cash: [[0.05,0],[0.10,0],[0.20,0],[0.50,0],[1.00,0],[2.00,0],[5,0],[10,0],[20,0],[50,0],[100,0],[200,0],[500,0]],
			bank: 1,
			bankTo: 1,
			balances: [] as BankBalance[],
			bankTypes: [] as BankType[],
			start: 500,
			startTransfer: false,
			showPrintModal: false,
			saldo: 0,
			cashierSettings: new CashierSettings(),
		};
	},
	props: {
		operation: String,
		amount: Number
	},
	computed: {
		bankNameFrom():string{
			return this.bankTypes.filter(c => c.ID == this.bank)[0]?.Name || "";
		},
		bankNameTo():string{
			return this.bankTypes.filter(c => c.ID == this.bankTo)[0]?.Name || "";
		},
		totalIn():number{
			let t = 0;
			this.cash.forEach((c) => t+= c[0]*c[1]);
			return t;
		},
		difference():number{
			return this.totalIn - this.saldo;
		},
		humandDifference():string{
			return printHumanFloat(this.difference);
		},
		toDeposit():number{
			return this.totalIn-this.start;
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		cancelTransfer(){
			this.startTransfer = false;
			this.startTransfer = false;
		},
		save(){
			this.startTransfer = true;
		},
		async transfer(){
			await this.payFrom();
			await this.payTo();
			if(this.difference){
				await this.payDifference();
			}
			this.$wf.notify(this.$ct("common.success").toString(), "success", 3000, "check");
			this.$emit("refresh");
			this.showPrintModal = true;
		},
		cancelPrint(){
			this.$emit("close");
		},
		print(){
			let w = window.open("", "PRINT", "height=400,width=600");
			let id = document.getElementById("print");
			if(w && id){
				w.document.write("<html style=\"margin:0; padding:0;\"><head><title>Winfakt Online - " +this.$ct("title").toString()+ "</title>");
				w.document.write("</head><body style='font-family: \"open sans\", \"sans-serif\"; margin:0; padding:0;' >");
				w.document.write("<b>" + this.$ct("print-document-title",{bank1: this.bankNameFrom})  + "</b>");
				w.document.write("<br><br><b>" + this.$ct("print-document-date")+ " " + printLocalDate(new Date()) + "</b>");
				w.document.write(id.innerHTML);
				w.document.write("</body></html>");
				w.document.close();
				w.focus();
				w.print();
				w.close();
			}
			this.$emit("close");
		},
		async payFrom(){
			let bank = new Bank();
			bank.Total = this.toDeposit * -1;
			bank.TotalDC = this.toDeposit * -1;
			bank.Kind = BankKind.Diverse;
			bank.BookYear = BookYearService.selectedBookYear;
			bank.TypeID = this.bank;
			bank.LedgerAccountCode = "580000";
			bank.Info = this.$ct("transfer-info-from").toString() + this.bankNameFrom;
			await BankService.postBooking(bank);
		},
		async payTo(){
			let bank = new Bank();
			bank.Total = this.toDeposit;
			bank.TotalDC = this.toDeposit;
			bank.Kind = BankKind.Diverse;
			bank.BookYear = BookYearService.selectedBookYear;
			bank.TypeID = this.bankTo;
			bank.LedgerAccountCode = "580000";
			bank.Info = this.$ct("transfer-info-to").toString() + this.bankNameTo;
			await BankService.postBooking(bank);
		},
		async payDifference(){
			let bank = new Bank();
			bank.Total = this.difference;
			bank.TotalDC = this.difference;
			bank.Kind = BankKind.Diverse;
			bank.BookYear = BookYearService.selectedBookYear;
			bank.TypeID = this.bank;
			bank.LedgerAccountCode = "499000";
			bank.Info = this.$ct("kas-difference").toString();
			await BankService.postBooking(bank);
		}
	},
	async mounted(){
		this.cashierSettings = await UserConfigService.getCashierSettings();
		this.start = this.cashierSettings.DefaultStartAmount;
		this.balances = await BankService.getAllBalances();
		this.bankTypes = await BankService.getTypes();
		this.saldo = 0;
		this.bank = DossierConfigService.getGeneralConfig().DefaultCashPaymentBankTypeID || 9;
		this.saldo = this.balances.filter(c => c.TypeID == this.bank)[0]?.Total || 0;
	},
	components: {
		AppSelectBankType
	},
	i18nEx: {
		componentPrefix: "components.sales.CashierCheck"
	},
});
